import React from "react";
import { RCCRefModalProps } from "react-common-components";
import { useTranslation } from "src/context/Translations/context";
import Modal from "../Modal";
import ModalSide from "../Modal/styles";
import Comments from "./Comments";
import IModalComments from "./interface";

const ModalComments: React.ForwardRefRenderFunction<RCCRefModalProps, IModalComments> = ({ 
	defaultValue,
	names,
	onAddComment,
	onDeleteComment,
	subtitle,
	onCallbackComments,
	disabled
}, ref) => {
	const { translate } = useTranslation();  
	return (
		<Modal
			ref={ref}
			header={{
				title: translate("Comentários"),
				subtitle,
				icon: {
					name: "comment"
				}
			}}
			footer= {{
				showSaveButton: false,
				buttonLoadingText: translate("Carregando"),
				saveButtonText: translate("Salvar"),
				cancelButtonText: translate("Cancelar")
			}}
			onClose={() => {
				if(onCallbackComments !== undefined)
					onCallbackComments();
			}}
			styleInline={ModalSide}
		>
			<Comments 
				defaultValue={defaultValue}
				names={names}
				onAddComment={onAddComment}
				onDeleteComment={onDeleteComment}
				disabled={disabled}
			/>
		</Modal>
	);
};

export default React.forwardRef(ModalComments);
